import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class DirectionsOverlay {
  public dialogRef: MatDialogRef<any>;

  constructor(public dialog: MatDialog) {}

  public open(
    component: any,
    origin: string,
    destination: string
  ): MatDialogRef<any> | void {
    this.dialogRef = this.dialog.open(component, {
      panelClass: 'directions-overlay',
      data: {
        origin: origin,
        destination: destination,
      },
    });
  }

  public close(): void {
    this.dialog.closeAll();
  }
}
